import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import type { CurrentStockResponse } from '../types'
import {
  CURRENT_STOCK_PATH,
  CURRENT_STOCK_QUERY_KEY,
  CURRENT_STOCK_URL
} from './queryConstants'

type UseCurrentStockProps = {
  residentMedicationId: string
  residentId: string
  enabled?: boolean
}

type UseCurrentStockReturn = {
  currentStock: CurrentStockResponse | null
  isLoading: boolean
  refetch: () => void
}

export const useCurrentStock = ({
  residentMedicationId,
  residentId,
  enabled = true
}: UseCurrentStockProps): UseCurrentStockReturn => {
  const params = getQueryParams({
    residentId
  })

  const { data, isLoading, refetch } = useQuery(
    [CURRENT_STOCK_QUERY_KEY, residentMedicationId, residentId],
    () =>
      getJSON({
        url: `${CURRENT_STOCK_URL}/${residentMedicationId}/${CURRENT_STOCK_PATH}?${params}`
      }),
    {
      enabled: enabled && !!residentMedicationId && !!residentId,
      retry: 1
    }
  )

  return {
    currentStock: (data as CurrentStockResponse) || null,
    isLoading,
    refetch
  }
}

export default useCurrentStock
